
import { Component, Vue, Watch } from "vue-property-decorator";
import IssuePermit from "@/views/manage/permits/IssuePermit.vue";

@Component({
  components: {
    IssuePermit,
  },
})
export default class RequestPermit extends Vue {
  dialogOpen = false;

  mounted() {
    // Automatically open the dialog when this component is mounted
    this.dialogOpen = true;
  }

  onReloadPermits() {
    // Handle permit reload if needed
    this.$router.push({ name: "dash.myPermits" });
  }

  // When dialog is closed, navigate back to dashboard
  @Watch("dialogOpen")
  onDialogOpenChange(val: boolean) {
    if (!val) {
      this.$router.push({ name: "dash.quickLinks" });
    }
  }
}
